import { render, staticRenderFns } from "./heroHomepage.vue?vue&type=template&id=50231f7a&"
import script from "./heroHomepage.vue?vue&type=script&lang=javascript&"
export * from "./heroHomepage.vue?vue&type=script&lang=javascript&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/one-stop-shop/one-stop-shop/one-stop-shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50231f7a')) {
      api.createRecord('50231f7a', component.options)
    } else {
      api.reload('50231f7a', component.options)
    }
    module.hot.accept("./heroHomepage.vue?vue&type=template&id=50231f7a&", function () {
      api.rerender('50231f7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/wp-content/themes/global-theme/views/blocks/heroHomepage/heroHomepage.vue"
export default component.exports